import { input } from '@angular/core';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
export class AgentDownloadLinkComponent {
    constructor() {
        this.url = input.required(...(ngDevMode ? [{ debugName: "url" }] : []));
        this.title = input.required(...(ngDevMode ? [{ debugName: "title" }] : []));
    }
}
AgentDownloadLinkComponent.ɵfac = function AgentDownloadLinkComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentDownloadLinkComponent)(); };
AgentDownloadLinkComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentDownloadLinkComponent, selectors: [["ycn-agent-download-link"]], inputs: { url: [1, "url"], title: [1, "title"] }, decls: 4, vars: 2, consts: [[1, "mt-1"], ["target", "_blank", 1, "btn", "btn-outline", "btn-gray", "width-full", "mb-1", 3, "href"], [1, "text-normal-case", "min-width-0", "text-ellipsis", 3, "textContent"], ["ycnIcon", "", "name", "icon-download", "role", "img", 1, "icon-download", "ml-1"]], template: function AgentDownloadLinkComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
        i0.ɵɵelement(2, "span", 2);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(3, "svg", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("href", ctx.url(), i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", ctx.title());
    } }, dependencies: [IconModule, i1.IconDirective], encapsulation: 2, changeDetection: 0 });
